import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type UpdatePaymentCardInput = {
  cardHolderName: string;
  cvc: string;
  expMonth: number;
  expYear: number;
  number: string;
  resourceIds: null | string[];
};

export type UpdatePaymentCardResponse = {
  status: string;
  error_code?: 'card_declined' | 'incorrect_number' | 'expired_card' | 'incorrect_cvc' | 'generic';
  error?: string;
};

export const updatePaymentCard = (data: UpdatePaymentCardInput) =>
  restClient.request<UpdatePaymentCardResponse>('/payment/card/save', {
    method: 'POST',
    data: snakecaseKeys(data)
  });

export const updateAutopayStatus = (autopayEnabled: boolean) =>
  restClient.request('/payment/set_autopay', {
    method: 'POST',
    data: {
      autopay_enabled: autopayEnabled,
    }
  });

export const payOutstandingBalance = (resourceIds: null | string[]) =>
  restClient.request('/payment/charge_outstanding_balance', {
    method: 'POST',
    data: {
      resource_ids: resourceIds,
    }
  });
